import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-down",
  "use": "icon-chevron-down-usage",
  "viewBox": "0 0 13 7.82",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 7.82\" id=\"icon-chevron-down\"><title>chevron-down</title><path d=\"M6.5,7.82,0,1.74,1.73,0,6.5,4.35,11.27,0,13,1.74Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/chevron-down.svg
// module id = 272
// module chunks = 0 1